const astationCoupon = () => import('../views/astation/coupon')

export default [
  {
    path: '/astation/coupon',
    name: 'astationCoupon',
    component: astationCoupon
  },
]